// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"hhjiIxDl82UEhnnU4kLbr","content":"SSyBZd154bMGzBV_HKKvN","titleWrapper":"Kte0glbjT9TQSWBTP-l5h","title":"_3OTY-GWGrlt9bHMCOYfIrA","underTitle":"X82XTuEy6H8COXaSz6t8o"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PlaceYourForeignProperty/PlaceYourForeignProperty.scss
// module id = 1692
// module chunks = 0